const chronicPrevalencePageConstants = {
  CHRONIC_PREVALENCE_PAGE: {
    TITLE: 'Chronic Prevalence',
    PREVALENCE_BY: 'Prevalence by',
    SUBTITLE: {
      PART1:
        'Understand the potential relationships between conditions and their effects on your population to mitigate multi-morbidity risks',
      PART2: ' to ',
      PART3: ' to plan intervention strategy',
    },
    SUMMARY_CARDS: {
      MEMBERS: 'Cohort Members',
      TOTAL_COST: 'Cohort Cost',
      PMPM: 'Cohort PMPM',
      PEPM: 'Cohort PEPM',
    },
    COHORT_DETAILS: {
      TITLE: 'Cohort Details',
      SUBTITLE:
        'Select the properties that you would like to apply to current data',
    },
    PREVALENCE_BY_CONDITION_GRAPH: {
      TITLE: 'No of Conditions by',
      SUB_TITLE_GENDER: 'Showing cost share and number of conditions by gender',
      SUB_TITLE_AGE_GROUP:
        'Showing cost share and number of conditions by age group',
      CATEGORIES: [
        {
          label: '1',
        },
        {
          label: '2',
        },
        {
          label: '3',
        },
        {
          label: '4',
        },
        {
          label: '5+',
        },
      ],
      TOOLTIP:
        'A member with multiple conditions, or comorbidities, can often signal the potential for higher risk.  Here we display the number of conditions members have, broken out by gender or age.',

      CHART_CATEGORIES: [
        {
          category: [
            {
              label: '1 Condition',
            },
            {
              label: '2 Conditions',
            },
            {
              label: '3 Conditions',
            },
            {
              label: '4 Conditions',
            },
            {
              label: '5 Conditions+',
            },
          ],
        },
      ],
    },
    PREVALENCE_CHART: {
      TITLE: 'Prevalence By Condition',
      SUB_TITLE:
        'Showing all the prevalence by conditions by their cost of care percentages',
    },
    POLY_DISEASE_PREVALENCE_DISTRIBUTION: {
      TITLE: 'Poly Disease Prevalence Distribution',
      SUB_TITLE: 'Showing cost share and prevalence by comorbidity',
      CATEGORIES: [
        {
          name: 'Good - >90th%',
        },
        {
          name: 'Average - 50th-90th%',
        },
        {
          name: 'Need Intervention - <50th%',
        },
      ],
      LEGENDS: [
        {
          label: '1 Condition',
          color: '#CFDCFF',
        },
        {
          label: '2 Conditions',
          color: '#9CB6FD',
        },
        {
          label: '3 Conditions',
          color: '#AFE9F5',
        },
        {
          label: '4 Conditions',
          color: '#F7D1CD',
        },
        {
          label: '5 Conditions',
          color: '#E8C2CA',
        },
      ],
    },
    MEMBER_HEALTH_DISTRIBUTION: {
      TITLE: 'Member Health Distribution',
      SUB_TITLE: 'Showing distribution between mental and physical conditions',
    },
  },
  MEMBER_SUMMARY_CARDS: {
    MEMBER_DETAILS: {
      TITLE: 'Member Details',
      SUB_TITLE: 'To see more about the member details click on a member',
    },
    TOP_DIAGNOSIS: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing the top ',
      DROPDOWN_OPTIONS: ['Diagnosis by Cost', 'Diagnosis by Member'],
    },
    TOP_MEDICATIONS: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing the top ',
      DROPDOWN_OPTIONS: ['Medications by Cost', 'Medications by Member'],
    },
    TOP_PROCEDURES: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing the top ',
      DROPDOWN_OPTIONS: ['Procedures by Cost', 'Procedures by Member'],
    },
    TOP_PROVIDERS: {
      TITLE: 'Top',
      SUB_TITLE: 'Showing the top ',
      DROPDOWN_OPTIONS: ['Providers by Cost', 'Providers by Member'],
    },
  },
};

export default chronicPrevalencePageConstants;
